import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.js';
import { createRecipe } from './create-recipe.js';

const docsMediaEmbedLayoutDefaultVariants = {
  "size": "full",
  "align": "center"
}
const docsMediaEmbedLayoutCompoundVariants = []

const docsMediaEmbedLayoutSlotNames = [
  [
    "root",
    "docsMediaEmbedLayout__root"
  ]
]
const docsMediaEmbedLayoutSlotFns = /* @__PURE__ */ docsMediaEmbedLayoutSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, docsMediaEmbedLayoutDefaultVariants, getSlotCompoundVariant(docsMediaEmbedLayoutCompoundVariants, slotName))])

const docsMediaEmbedLayoutFn = memo((props = {}) => {
  return Object.fromEntries(docsMediaEmbedLayoutSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const docsMediaEmbedLayoutVariantKeys = [
  "size",
  "align"
]
const getVariantProps = (variants) => ({ ...docsMediaEmbedLayoutDefaultVariants, ...compact(variants) })

export const docsMediaEmbedLayout = /* @__PURE__ */ Object.assign(docsMediaEmbedLayoutFn, {
  __recipe__: false,
  __name__: 'docsMediaEmbedLayout',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: docsMediaEmbedLayoutVariantKeys,
  variantMap: {
  "size": [
    "full",
    "large",
    "medium",
    "small"
  ],
  "align": [
    "left",
    "center",
    "right"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, docsMediaEmbedLayoutVariantKeys)
  },
  getVariantProps
})